const TrackingReadyEventName = 'trackingReady';

declare interface TrackingApi {
  track: (name: string, properties: any) => void;
}

declare global {
  interface Window {
    tracking?: TrackingApi | undefined;
  }
}

function onTrackingReady(callback: (tracking: TrackingApi) => void) {
  if (typeof window === 'undefined') return;

  const listener = () => {
    if (window.tracking) {
      callback(window.tracking);
    }
    window.removeEventListener(TrackingReadyEventName, listener);
  };

  if (window && window.tracking && window.tracking.track) {
    callback(window.tracking);
  } else {
    window.addEventListener(TrackingReadyEventName, listener);
  }
}

export function track(event: string, properties: any) {
  onTrackingReady(tracking => {
    tracking.track(event, properties);
  });
}
